(function (global) {
  if (global.WeinexpertisePdf) return;

  var CAPTURE_WIDTH = 794;
  var PAGE_MARGIN_MM = 5;
  var loadingPromise = null;
  var screenshotPromise = null;
  var HOST_STYLE_ID = "weinexpertise-pdf-host-style";

  function shopRoot() {
    if (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) {
      return global.Shopify.routes.root;
    }
    return "/";
  }

  function html2pdfSrc() {
    return (global.__WEINEXPERTISE_HTML2PDF_SRC__ || "").trim();
  }

  function screenshotSrc() {
    return (global.__WEINEXPERTISE_SCREENSHOT_SRC__ || "").trim();
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = function () {
        reject(new Error("Failed to load " + src));
      };
      document.head.appendChild(script);
    });
  }

  function loadHtml2Pdf() {
    if (global.html2pdf) return Promise.resolve(global.html2pdf);
    if (loadingPromise) return loadingPromise;
    loadingPromise = loadScript(html2pdfSrc()).then(function () {
      if (!global.html2pdf) throw new Error("html2pdf failed to load");
      return global.html2pdf;
    }).catch(function (err) {
      loadingPromise = null;
      throw err;
    });
    return loadingPromise;
  }

  function loadScreenshot() {
    if (global.modernScreenshot && global.modernScreenshot.domToCanvas) {
      return Promise.resolve(global.modernScreenshot);
    }
    if (screenshotPromise) return screenshotPromise;
    var src = screenshotSrc();
    if (!src) return Promise.reject(new Error("modern-screenshot asset URL missing"));
    screenshotPromise = loadScript(src).then(function () {
      if (!global.modernScreenshot || !global.modernScreenshot.domToCanvas) {
        throw new Error("modern-screenshot failed to load");
      }
      return global.modernScreenshot;
    }).catch(function (err) {
      screenshotPromise = null;
      throw err;
    });
    return screenshotPromise;
  }

  function ensureCaptureStyle() {
    var style = document.getElementById(HOST_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = HOST_STYLE_ID;
      document.head.appendChild(style);
    }
    style.textContent =
      "#weinexpertise-pdf-host{" +
      "position:fixed!important;left:-10000px!important;top:0!important;" +
      "width:" +
      CAPTURE_WIDTH +
      "px!important;background:#fff!important;" +
      "pointer-events:none!important;overflow:visible!important;" +
      "opacity:0!important;z-index:-1!important;" +
      "}" +
      "#weinexpertise-pdf-host.is-capturing{" +
      "opacity:1!important;z-index:-1!important;" +
      "}" +
      "#weinexpertise-pdf-overlay{" +
      "position:fixed!important;inset:0!important;background:#fff!important;" +
      "z-index:2147483646!important;display:none!important;" +
      "align-items:center!important;justify-content:center!important;" +
      "font-family:Opensans,sans-serif;font-size:16px;color:#0a0a0a;" +
      "}" +
      "#weinexpertise-pdf-overlay.is-active{display:flex!important;}" +
      "#weinexpertise-pdf-host .section_print-wrapper," +
      "#weinexpertise-pdf-host .shopify-section{" +
      "display:block!important;visibility:visible!important;opacity:1!important;" +
      "}" +
      "#weinexpertise-pdf-host .print_a4-wrapper," +
      "#weinexpertise-pdf-host .print-expertise{" +
      "display:block!important;visibility:visible!important;" +
      "width:" +
      CAPTURE_WIDTH +
      "px!important;max-width:" +
      CAPTURE_WIDTH +
      "px!important;margin:0!important;background:#fff;box-sizing:border-box;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__card{" +
      "display:grid!important;width:100%!important;overflow:visible!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes{" +
      "display:block!important;width:100%!important;max-width:none!important;" +
      "place-items:unset!important;flex:unset!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-table{" +
      "width:100%!important;border-collapse:separate!important;" +
      "border-spacing:0 14px!important;table-layout:fixed!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-icon-cell{" +
      "width:42px!important;min-width:42px!important;max-width:42px!important;" +
      "padding:0 16px 0 0!important;vertical-align:top!important;box-sizing:border-box!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-text-cell{" +
      "padding:0!important;vertical-align:top!important;text-align:left!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-icon-cell .weinbeschreibung_icon," +
      "#weinexpertise-pdf-host .print-expertise__notes-icon-cell .weinbeschreibung_icon.is-print{" +
      "width:26px!important;height:26px!important;max-height:none!important;" +
      "object-fit:contain!important;display:block!important;margin:0!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-text-cell .print_text.is-text{" +
      "margin:0!important;font-size:12px!important;line-height:1.45!important;text-align:left!important;" +
      "}" +
      "#weinexpertise-pdf-host .print-expertise__notes-title{" +
      "display:block!important;padding:0!important;margin:0!important;" +
      "max-width:none!important;width:100%!important;box-sizing:border-box!important;" +
      "text-align:left!important;" +
      "}";
  }

  function alignNotesHeadline(root) {
    if (!root) return;
    Array.prototype.forEach.call(
      root.querySelectorAll(".print-expertise__notes-table"),
      function (table) {
        table.style.setProperty("width", "100%", "important");
        table.style.setProperty("border-collapse", "separate", "important");
        table.style.setProperty("border-spacing", "0 14px", "important");
        table.style.setProperty("table-layout", "fixed", "important");
      }
    );
    Array.prototype.forEach.call(
      root.querySelectorAll(".print-expertise__notes-icon-cell"),
      function (cell) {
        cell.style.setProperty("width", "42px", "important");
        cell.style.setProperty("min-width", "42px", "important");
        cell.style.setProperty("max-width", "42px", "important");
        cell.style.setProperty("padding", "0 16px 0 0", "important");
        cell.style.setProperty("vertical-align", "top", "important");
      }
    );
    Array.prototype.forEach.call(
      root.querySelectorAll(".print-expertise__notes-text-cell"),
      function (cell) {
        cell.style.setProperty("padding", "0", "important");
        cell.style.setProperty("vertical-align", "top", "important");
        cell.style.setProperty("text-align", "left", "important");
      }
    );
    Array.prototype.forEach.call(
      root.querySelectorAll(".print-expertise__notes-title"),
      function (title) {
        title.style.setProperty("display", "block", "important");
        title.style.setProperty("padding", "0", "important");
        title.style.setProperty("margin", "0", "important");
        title.style.setProperty("max-width", "none", "important");
        title.style.setProperty("text-align", "left", "important");
      }
    );
  }

  function ensureOverlay() {
    var overlay = document.getElementById("weinexpertise-pdf-overlay");
    if (overlay) return overlay;
    overlay = document.createElement("div");
    overlay.id = "weinexpertise-pdf-overlay";
    overlay.setAttribute("aria-hidden", "true");
    overlay.textContent = "Weinexpertise wird erstellt…";
    document.body.appendChild(overlay);
    return overlay;
  }

  function ensureCaptureHost() {
    ensureCaptureStyle();
    var host = document.getElementById("weinexpertise-pdf-host");
    if (host) return host;
    host = document.createElement("div");
    host.id = "weinexpertise-pdf-host";
    host.setAttribute("aria-hidden", "true");
    document.body.appendChild(host);
    return host;
  }

  function prepareImages(root) {
    Array.prototype.forEach.call(root.querySelectorAll("img"), function (img) {
      var src = img.getAttribute("src") || img.currentSrc;
      if (!src) return;
      img.setAttribute("crossorigin", "anonymous");
      img.loading = "eager";
      try {
        img.src = new URL(src, global.location.origin).href;
      } catch (e) {
        img.src = src;
      }
    });
  }

  function waitForImages(root) {
    prepareImages(root);
    var images = Array.prototype.slice.call(root.querySelectorAll("img"));
    if (!images.length) return Promise.resolve();

    return Promise.all(
      images.map(function (img) {
        if (img.complete && img.naturalWidth) return Promise.resolve();
        return new Promise(function (resolve) {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      })
    );
  }

  function sanitizeFilename(value) {
    return String(value || "Weinexpertise")
      .replace(/[\\/:*?"<>|]+/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .slice(0, 80);
  }

  function filenameFromRoot(root, fallback) {
    var skuEl = root.querySelector(".print-expertise__sku span");
    var sku = skuEl ? skuEl.textContent.trim() : "";
    var titleEl = root.querySelector(".print-expertise__title");
    var title = titleEl ? titleEl.textContent.trim() : "";
    var base = sku || title || fallback || "Weinexpertise";
    return "Weinexpertise-" + sanitizeFilename(base) + ".pdf";
  }

  function elementToHtml(element) {
    if (!element) return "";
    var section = element.closest
      ? element.closest(".section_print-wrapper, .shopify-section")
      : null;
    return (section || element).outerHTML;
  }

  function mountHtml(html) {
    var host = ensureCaptureHost();
    host.innerHTML = html;
    var target =
      host.querySelector(".print-expertise") ||
      host.querySelector(".print_a4-wrapper") ||
      host.firstElementChild;
    return { host: host, target: target };
  }

  function saveCanvasAsA4Pdf(html2pdf, canvas, filename) {
    return html2pdf()
      .set({
        margin: 0,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 1 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: [] }
      })
      .from(canvas)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        var pageWidth = pdf.internal.pageSize.getWidth();
        var pageHeight = pdf.internal.pageSize.getHeight();
        var usableWidth = pageWidth - PAGE_MARGIN_MM * 2;
        var usableHeight = pageHeight - PAGE_MARGIN_MM * 2;

        var imgWidth = usableWidth;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        if (imgHeight > usableHeight) {
          imgHeight = usableHeight;
          imgWidth = (canvas.width * imgHeight) / canvas.height;
        }

        var x = PAGE_MARGIN_MM + (usableWidth - imgWidth) / 2;
        var y = PAGE_MARGIN_MM;

        var total = pdf.getNumberOfPages();
        for (var i = total; i >= 1; i--) {
          pdf.deletePage(i);
        }
        pdf.addPage();
        pdf.setPage(1);
        pdf.addImage(
          canvas.toDataURL("image/jpeg", 0.98),
          "JPEG",
          x,
          y,
          imgWidth,
          imgHeight
        );

        var blob = pdf.output("blob");
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        global.setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 1500);
      });
  }

  function captureAndDownload(html, filename, options) {
    var opts = options || {};
    var showOverlay = opts.showOverlay !== false;

    return Promise.all([loadHtml2Pdf(), loadScreenshot()]).then(function (libs) {
      var html2pdf = libs[0];
      var modernScreenshot = libs[1];
      var mounted = mountHtml(html);
      var host = mounted.host;
      var target = mounted.target;
      var overlay = showOverlay ? ensureOverlay() : null;

      if (!target) {
        host.innerHTML = "";
        return Promise.reject(new Error("Expertise markup missing"));
      }

      var name = filename || filenameFromRoot(host, "Weinexpertise");
      if (overlay) overlay.classList.add("is-active");
      host.classList.add("is-capturing");
      if (showOverlay) global.scrollTo(0, 0);

      return waitForImages(host)
        .then(function () {
          return new Promise(function (resolve) {
            global.requestAnimationFrame(function () {
              global.setTimeout(resolve, 250);
            });
          });
        })
        .then(function () {
          alignNotesHeadline(host);
          return new Promise(function (resolve) {
            global.requestAnimationFrame(function () {
              global.setTimeout(resolve, 50);
            });
          });
        })
        .then(function () {
          var width = Math.ceil(
            Math.max(target.scrollWidth, target.offsetWidth, CAPTURE_WIDTH)
          );
          var height = Math.ceil(
            Math.max(target.scrollHeight, target.offsetHeight, 1)
          );

          return modernScreenshot.domToCanvas(target, {
            width: width,
            height: height,
            scale: 2,
            backgroundColor: "#ffffff",
            style: {
              width: width + "px",
              height: height + "px",
              transform: "none",
              margin: "0"
            }
          });
        })
        .then(function (canvas) {
          return saveCanvasAsA4Pdf(html2pdf, canvas, name);
        })
        .finally(function () {
          host.classList.remove("is-capturing");
          host.innerHTML = "";
          if (overlay) overlay.classList.remove("is-active");
        });
    });
  }

  function downloadFromElement(element, filename, options) {
    if (!element) return Promise.reject(new Error("Missing expertise element"));
    return captureAndDownload(elementToHtml(element), filename, options);
  }

  function fetchExpertiseHtml(handle) {
    var endpoint =
      shopRoot() +
      "products/" +
      encodeURIComponent(handle) +
      "?sections=print_product";

    return fetch(endpoint, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("Expertise section request failed");
        return res.json();
      })
      .then(function (data) {
        var html = data && data.print_product;
        if (!html) throw new Error("Expertise section missing");
        return html;
      });
  }

  function downloadForProductHandle(handle, filename) {
    return fetchExpertiseHtml(handle).then(function (html) {
      return captureAndDownload(html, filename, { showOverlay: true });
    });
  }

  function downloadFromPage(filename) {
    var target =
      document.querySelector(".section_print-wrapper .print-expertise") ||
      document.querySelector(".print-expertise") ||
      document.querySelector(".print_a4-wrapper");
    return downloadFromElement(target, filename, { showOverlay: false });
  }

  global.WeinexpertisePdf = {
    downloadFromElement: downloadFromElement,
    downloadForProductHandle: downloadForProductHandle,
    downloadFromPage: downloadFromPage,
    fetchExpertiseHtml: fetchExpertiseHtml,
    shopRoot: shopRoot
  };
})(window);
